export default __webpack_public_path__ + "static/media/DRC-Card-Barcode.c6f1b477.svg";